import { render, staticRenderFns } from "./DashboardReportingHistoryView.vue?vue&type=template&id=4b8a8a14&scoped=true&"
import script from "./DashboardReportingHistoryView.vue?vue&type=script&lang=js&"
export * from "./DashboardReportingHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReportingHistoryView.vue?vue&type=style&index=0&id=4b8a8a14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a8a14",
  null
  
)

/* custom blocks */
import block0 from "./DashboardReportingHistoryView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports